"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ArrowIndicatorDownOutline_1 = __importDefault(require("../icons/generated/ArrowIndicatorDownOutline"));
var ArrowIndicatorUpOutline_1 = __importDefault(require("../icons/generated/ArrowIndicatorUpOutline"));
var dropdown_style_component_1 = require("./dropdown.style.component");
var text_field_style_component_1 = require("../inputs/text-field.style.component");
var use_outside_hover_hook_1 = __importDefault(require("../../hooks/use-outside-hover.hook"));
var text_field_component_1 = __importDefault(require("../inputs/text-field.component"));
var translations_context_1 = __importDefault(require("../../context/translations/translations.context"));
var cuid_1 = __importDefault(require("cuid"));
var dropdown_component_1 = require("./dropdown.component");
var DropdownWithSearch = function (_a) {
    var title = _a.title, options = _a.options, value = _a.value, defaultOption = _a.defaultOption, disabled = _a.disabled, onChange = _a.onChange, hiddenLabels = _a.hiddenLabels;
    var wrapperRef = react_1.useRef(null);
    var _b = react_1.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = react_1.useState(false), mouseHover = _c[0], setMouseHover = _c[1];
    var _d = react_1.useState(dropdown_component_1.findSelected(options, value)), selected = _d[0], setSelected = _d[1];
    var _e = react_1.useState([]), filteredOptions = _e[0], setFilteredOptions = _e[1];
    var _f = react_1.useState([]), baseOptions = _f[0], setBaseOptions = _f[1];
    var _g = react_1.useState(''), searchValue = _g[0], setSearchValue = _g[1];
    var getTranslation = react_1.useContext(translations_context_1.default).getTranslation;
    react_1.useEffect(function () {
        var updatedOptions = options.map(function (option) { return (__assign(__assign({}, option), { id: cuid_1.default() })); });
        setFilteredOptions(updatedOptions);
        setBaseOptions(updatedOptions);
    }, [options]);
    use_outside_hover_hook_1.default(mouseHover, setIsOpen);
    function getFilteredOptions(val) {
        var lowerCasedVal = val.toLowerCase();
        setSearchValue(val);
        setFilteredOptions(baseOptions.filter(function (option) { return option.label.toLowerCase().indexOf(lowerCasedVal) === 0; }));
    }
    return (react_1.default.createElement(dropdown_style_component_1.Container, null,
        title && react_1.default.createElement(text_field_style_component_1.Title, null, title),
        react_1.default.createElement(dropdown_style_component_1.Wrapper, { ref: wrapperRef, onMouseOver: function () { return setMouseHover(true); }, onClick: function () { return setIsOpen(true); }, onMouseOut: function () { return setMouseHover(false); }, disabled: disabled },
            react_1.default.createElement(dropdown_style_component_1.ChosenOptionContainer, { disabled: disabled },
                (!hiddenLabels || (hiddenLabels && !isOpen)) &&
                    (selected ? react_1.default.createElement(dropdown_style_component_1.Field, null, selected) : react_1.default.createElement(dropdown_style_component_1.DefaultOption, null, defaultOption)),
                isOpen ? !hiddenLabels && react_1.default.createElement(ArrowIndicatorUpOutline_1.default, null) : react_1.default.createElement(ArrowIndicatorDownOutline_1.default, null)),
            isOpen && (react_1.default.createElement(text_field_component_1.default, { id: 'asset-search', value: searchValue, onChange: getFilteredOptions, placeholder: getTranslation('GLOBAL:SEARCH') }))),
        isOpen && (react_1.default.createElement(dropdown_style_component_1.Drawer, null,
            react_1.default.createElement(dropdown_style_component_1.OptionsList, null, filteredOptions.map(function (option) { return (react_1.default.createElement(dropdown_style_component_1.OptionsListElement, { onClick: function () {
                    setSelected(option.label);
                    onChange && onChange(option.value);
                    setSearchValue('');
                    setFilteredOptions(baseOptions);
                }, key: option.id }, option.label)); }))))));
};
DropdownWithSearch.displayName = 'DropdownWithSearch';
exports.default = DropdownWithSearch;
